import { useCallback } from "react";
import type { NavigateOptions } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useCurrentDataStore } from "~/lqs";
import type { DataStorePathGenerator } from "./types";

export function useNavigateDataStore() {
  const normalizeDataStorePath = useNormalizeDataStorePath();

  const navigate = useNavigate();

  return useCallback(
    (generator: DataStorePathGenerator, options?: NavigateOptions) => {
      const path = normalizeDataStorePath(generator);

      navigate(path, options);
    },
    [normalizeDataStorePath, navigate],
  );
}

export function useNormalizeDataStorePath() {
  const dataStore = useCurrentDataStore();

  return useCallback(
    (generator: DataStorePathGenerator) => {
      return generator(dataStore);
    },
    [dataStore],
  );
}
